import * as React from 'react';
import { SubtotalsListItem } from './SubtotalsListItem';
import { translate } from 'react-i18next';
export var Discount = translate()(function (_a) {
    var discountRate = _a.discountRate, discountAmount = _a.discountAmount, moneyFormatter = _a.moneyFormatter, t = _a.t;
    return discountRate ? (React.createElement(SubtotalsListItem, { dataHook: "discount", label: "".concat(t('quote.form.discount'), " (").concat(discountRate, "%)"), value: moneyFormatter(discountAmount) })) : null;
});
//# sourceMappingURL=Discount.js.map